import React, { useEffect } from "react";
import lottie from "lottie-web";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const LoadingPopup = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { t } = useTranslation();

  useEffect( () => {
    const animation = lottie.loadAnimation( {
      container : document.querySelector( '#img_lc_05_04' ),
      path : `${ process.env.PUBLIC_URL }/static/json/img_lc_05_04.json`,
      renderer : 'svg',
      loop : true,
      autoplay : true
    } );
    animation.setSpeed( 0.65 );
    return () => {
      animation.destroy();
    };
  }, [] );

  return (
    <div className="la-wrap">
      <div className="la-ani la-next-ing">
        <div id="img_lc_05_04" className="anim-wrap" />
      </div>
      <div className="la-ani_txt">{ answeringQuestions.answeringCount ? t( 'LC_05_20.msg021' ) : t( 'LC_05_20.msg020' ) }</div>
    </div>
  );

};

export default LoadingPopup;
